import React from 'react'
import DocumentTitle from 'react-document-title'
import { Typography } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { Container } from 'components/layout'
import { generatePageTitle } from 'utils/generateAppDefaults'

const useStyles = makeStyles(theme => ({
  container: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)} ${theme.spacing(1)}`,
  },
}))

export interface ISpotQuoteToolContainerProps {
  children: React.ReactNode
}

export enum TABS {
  generateQuote = 'Generate Quote',
  searchQuotes = 'Search Quotes',
}

export const SpotQuoteToolContainer = ({ children }: ISpotQuoteToolContainerProps) => {
  const classes = useStyles()
  return (
    <DocumentTitle title={generatePageTitle('Spot Quote Tool')}>
      <Container hidePadding>
        <Box mb={1} className={classes.container}>
          <Typography variant='h2' data-test='title'>
            Spot Quote Tool
          </Typography>
        </Box>
        <Box>{children}</Box>
      </Container>
    </DocumentTitle>
  )
}
